module.exports = __webpack_public_path__ + "assets/e8c322de9658cbeb8a774b6624167c2c.woff2";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/semantic/themes/default/assets/fonts/brand-icons.woff2
// module id = 3649
// module chunks = 0